// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1OOab","bigColWidth":"Table_bigColWidth__3mH7H","biggerColWidth":"Table_biggerColWidth__wRoGd","row":"Table_row__5agKF","col":"Table_col__3sMY6"};